import { render, staticRenderFns } from "./VTextAreaWithValidation.vue?vue&type=template&id=df3953e6&"
import script from "./VTextAreaWithValidation.vue?vue&type=script&lang=ts&"
export * from "./VTextAreaWithValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports